module.exports = __webpack_public_path__ + "img/maqiang.f5befa62.jpg";